import dayjs from 'dayjs';

export default function getTimeAgo(time: number | null): string {
    if (time === null) {
        return '? ago';
    }

    const now = dayjs().unix();
    if (now < time) {
        return '';
    }

    const diff = now - time;
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);

    let result = '';
    if (hours) {
        result += `${hours} hr${hours > 1 ? 's' : ''}`;
    }
    if (minutes) {
        if (result.length > 0) {
            result += ', ';
        }
        result += `${minutes} min${minutes > 1 ? 's' : ''}`;
    }

    result += ' ago';
    return result;
}
